













import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import contentBlock from './components/ContentBlock.vue'
import contentBlockSaleTop from './components/ContentBlockSaleTop.vue'
import contentBlockBuyTop from './components/ContentBlockBuyTop.vue'
const loginerModule = namespace('loginer')
@Component({
	components: {
		contentBlock,
		contentBlockSaleTop,
		contentBlockBuyTop
	}
})
export default class Home extends Vue {
	@loginerModule.Mutation('SET_LOGINER') private setLoginer!: any
	private todoOrderList: object = []
	private toSendOrderList: object = []
	private saleTop: object = []
	private buyTop: object = []
	private created () {
		this.initHome()
	}
	private initHome () {
		return Promise.all([
			this.getTodoOrderList(),
			this.getToSendOrderList(),
			this.getSaleTopList(),
			this.getBuyTopList(),
			this.getNotifyNumber()
		])
	}
	private getTodoOrderList (): void {
		const params = {
			bill_state: '10',
			start_date: '',
			end_date: '',
			keyword: '',
			length: 10,
			start: 0
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/billList',
			data: params
		}).then((res: object) => {
			this.todoOrderList = res || []
		})
	}
	private getToSendOrderList (): void {
		const params = {
			bill_state: '11',
			start_date: '',
			end_date: '',
			keyword: '',
			length: 10,
			start: 0
		}
		return (this as any).$fxHttp.requestPost({
			url: '/business/billList',
			data: params
		}).then((res: object) => {
			this.toSendOrderList = res || []
		})
	}
	private getSaleTopList (): void {
		return (this as any).$fxHttp.requestPost({
			url: '/business/getAmountTopTen'
		}).then((res: object) => {
			this.saleTop = res
		})
	}
	private getBuyTopList (): void {
		return (this as any).$fxHttp.requestPost({
			url: '/business/getSaleMoneyTopTen'
		}).then((res: object) => {
			this.buyTop = res
		})
	}
	private getNotifyNumber (): void {
		return (this as any).$fxHttp.requestGet({
			url: '/announcement/count'
		}).then((res: any) => {
			this.setLoginer({
				loginerNotifyNumber: res.unReadAnnoCount ? res.unReadAnnoCount : ''
			})
		})
	}
	private onItemClick (item: any): void {
		this.$router.push({ path: 'restaurantOrdersDetails', query: { id: item.id } })
	}
}
